import { getWelcomeMessage } from "asos-site-chrome-store-presentation";

const getWelcomeMessageAlreadyClosed = () => {
  const welcomeMessageClosedCookie = getWelcomeMessage();

  return welcomeMessageClosedCookie;
};

export default getWelcomeMessageAlreadyClosed;
